import { render, staticRenderFns } from "./JoinPersonal.vue?vue&type=template&id=35ae60d4&scoped=true"
import script from "./JoinPersonal.vue?vue&type=script&lang=ts"
export * from "./JoinPersonal.vue?vue&type=script&lang=ts"
import style0 from "./JoinPersonal.vue?vue&type=style&index=0&id=35ae60d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ae60d4",
  null
  
)

export default component.exports